import axios from '../axios-init';

export const getDiscountList = params => {
    return axios.post(`/discount/getDiscountList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editDiscount = params => {
    return axios.post(`/discount/addOrEditDiscount`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};





// WEBPACK FOOTER //
// ./src/api/discountService.js